module.exports = __webpack_public_path__ + "static/media/miss-g.4e527ab3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/miss-g.jpg
// module id = 1647
// module chunks = 0